export type LayoutConfig = {
  viewerOnly: true
} | {
  viewerOnly: false
  contentGridTemplate?: string
}

export const DEFAULT_LAYOUT_CONFIG = {
  viewerOnly: false,
  contentGridTemplate: `
    "models viewer elementData" 1fr
    "viewpoints viewer elementData" 1fr
    / 22rem 1fr 22rem
  `
} as const satisfies LayoutConfig
